import LegalLayout from "@/components/legal/legal-layout"
import content from "@/content/legal/cookies.md?raw"

export default function Cookies() {
  return <LegalLayout title="Política de Cookies" content={content} />
}
